export const InlineFormTestIdFactory = {
    getInlineFormBase: () => 'inline-form',
    getInlineFormCancelButton: (fieldName) => [InlineFormTestIdFactory.getInlineFormBase(), 'cancel', fieldName].join('-'),
    getInlineFormSaveButton: (fieldName) => [
        InlineFormTestIdFactory.getInlineFormBase(),
        'confirm',
        fieldName,
    ].join('-'),
    getInlineFormLabel: (fieldName) => [InlineFormTestIdFactory.getInlineFormBase(), 'label', fieldName].join('-'),
    getInlineFormDescription: (fieldName) => [
        InlineFormTestIdFactory.getInlineFormBase(),
        'description',
        fieldName,
    ].join('-'),
};
